import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useState, useEffect } from "react";
import { useTranslation } from "@i18n";
import Navigation from "../Navigation/Navigation";
import Question from "../Question/Question";
import stl from "./Questions.module.css";
import ProgressBar from "../ProgressBar/ProgressBar";
import Layout from "@/_LayoutsRelated/layout/Layout";
import AfterSubmitComp from "../AfterSubmitComp/AfterSubmitComp";
import { trackEvents } from "@/common/events/events";
import { CDN_LINK } from "@globalConfig";
import { api__surveySubmitQuestion } from "@/apis/survey/survey";
import useHelpers from "@hooks/useHelpers";
var Questions = function Questions(_ref) {
  var questions = _ref.questions,
    order_id = _ref.order_id,
    survey_id = _ref.survey_id,
    setIsSurveyDone = _ref.setIsSurveyDone,
    isCancelled = _ref.isCancelled,
    isFinance = _ref.isFinance,
    username = _ref.username,
    questionsCount = _ref.questionsCount,
    commonG4Data = _ref.commonG4Data;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useTranslation = useTranslation(["web_survey"]),
    t = _useTranslation.t;
  var _useState = useState(0),
    activeQuestionsIndex = _useState[0],
    setActiveQuestionsIndex = _useState[1];
  var _useState2 = useState(true),
    showStartingPage = _useState2[0],
    setShowStartingPage = _useState2[1];
  var _useState3 = useState(false),
    isLastQuestion = _useState3[0],
    setIsLastQuestion = _useState3[1];
  var _useState4 = useState(questionsCount - questions.length),
    activeQIndex = _useState4[0],
    setActiveQIndex = _useState4[1];
  var _useState5 = useState(""),
    error = _useState5[0],
    setError = _useState5[1];
  var _useState6 = useState(false),
    showError = _useState6[0],
    setShowError = _useState6[1];
  var _useState7 = useState({
      mainAnswer: "",
      secondaryOptions: [],
      secondaryAnswer: [],
      secondaryType: null,
      otherDetails: "",
      isOpen: false,
      isRequired: false
    }),
    answer = _useState7[0],
    setAnswer = _useState7[1];
  useEffect(function () {
    if (questions[activeQuestionsIndex].is_required) {
      setAnswer(function (pre) {
        return _objectSpread(_objectSpread({}, pre), {}, {
          isRequired: true
        });
      });
    }
    if (activeQuestionsIndex === questions.length - 1) setIsLastQuestion(true);
  }, [activeQuestionsIndex]);
  useEffect(function () {
    // set Question type to open based on the currunt question type
    var isOpenQst = questions[activeQuestionsIndex].answer_type === 1;
    if (isOpenQst) setAnswer(function (pre) {
      return _objectSpread(_objectSpread({}, pre), {}, {
        isOpen: true
      });
    });
  }, [activeQuestionsIndex, questions]);
  var getNextQuestion = function getNextQuestion() {
    //g4_data
    trackEvents("survey_progress", _objectSpread(_objectSpread({}, commonG4Data), {}, {
      question_order: activeQIndex + 1
    }));
    // reset answers and errors on every submit
    setAnswer({
      mainAnswer: "",
      secondaryAnswer: [],
      secondaryType: null,
      secondaryOptions: [],
      otherDetails: "",
      isOpen: false,
      isRequired: false
    });
    setActiveQIndex(function (prevIndex) {
      return prevIndex + 1;
    });
    setError("");
    if (isLastQuestion) {
      setIsSurveyDone(true);
      return;
    }
    setActiveQuestionsIndex(function (pre) {
      return pre + 1;
    });
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var data, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (!(answer.secondaryOptions.length && !answer.secondaryAnswer.length)) {
              _context.n = 1;
              break;
            }
            setError(t("select_one_options", {
              ns: "web_survey"
            }));
            return _context.a(2);
          case 1:
            if (!(answer.isRequired && !answer.isOpen && !answer.mainAnswer)) {
              _context.n = 2;
              break;
            }
            setError(t("select_one_options", {
              ns: "web_survey"
            }));
            return _context.a(2);
          case 2:
            if (!(answer.isRequired && answer.isOpen && !answer.otherDetails)) {
              _context.n = 3;
              break;
            }
            setError(t("validation_field_filled", {
              ns: "web_survey"
            }));
            return _context.a(2);
          case 3:
            if (!(!answer.isRequired && !isLastQuestion && !answer.mainAnswer || !answer.isRequired && !isLastQuestion && !answer.otherDetails)) {
              _context.n = 4;
              break;
            }
            getNextQuestion();
            return _context.a(2);
          case 4:
            _context.p = 4;
            _context.n = 5;
            return api__surveySubmitQuestion(order_id, survey_id, questions[activeQuestionsIndex].id, answer.mainAnswer, answer.otherDetails, answer.secondaryAnswer, isLastQuestion ? 1 : 0, isCancelled, isFinance);
          case 5:
            data = _context.v;
            getNextQuestion();
            //g4_data
            isLastQuestion && trackEvents("survey_submit", _objectSpread({}, data.g4_data));
            _context.n = 7;
            break;
          case 6:
            _context.p = 6;
            _t = _context.v;
            setShowError(true);
          case 7:
            return _context.a(2);
        }
      }, _callee, null, [[4, 6]]);
    }));
    return function handleSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();
  if (showError) {
    return /*#__PURE__*/React.createElement(Layout, {
      hideOrangeHeadBtn: true,
      hideFooter: true,
      hideSideMenue: true,
      hideAppBanner: true
    }, /*#__PURE__*/React.createElement(AfterSubmitComp, {
      imgPath: CDN_LINK + "/assets/images/survey_error_msg.svg",
      title: t("error_apologize", {
        ns: "web_survey"
      }),
      message: t("questionnaire_sent_technical_problem_try", {
        ns: "web_survey"
      }),
      buttonText: t("go_homepage", {
        ns: "web_survey"
      }),
      onClick: function onClick() {
        return navigateTo("/");
      }
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, showStartingPage ? /*#__PURE__*/React.createElement(AfterSubmitComp, {
    imgPath: CDN_LINK + "/assets/images/survey_start.svg",
    title: t("\u062D\u064A\u0627\u0643 ".concat(username, "\u060C"), {
      ns: "web_survey"
    }),
    subTitle: t("how_experience", {
      ns: "web_survey"
    }),
    message: t("appreciate_sharing_rating_improve_service", {
      ns: "web_survey"
    }),
    buttonText: t("start", {
      ns: "web_survey"
    }),
    className: stl.customText,
    onClick: function onClick() {
      setShowStartingPage(false);
      trackEvents("survey_start", commonG4Data);
    }
  }) : /*#__PURE__*/React.createElement("div", {
    className: stl.wrapper
  }, /*#__PURE__*/React.createElement("h2", {
    className: stl.welocomTitle
  }, isCancelled ? t("cancelled_order_survey", {
    ns: "web_survey"
  }) : t("receiving_car_satisfaction_survey", {
    ns: "web_survey"
  })), /*#__PURE__*/React.createElement(ProgressBar, {
    questions: questions,
    activeQuestionsIndex: activeQuestionsIndex,
    questionsCount: questionsCount,
    activeQIndex: activeQIndex
  }), /*#__PURE__*/React.createElement(Question, {
    question: questions[activeQuestionsIndex],
    mainAnswer: answer.mainAnswer,
    secondaryOptions: answer.secondaryOptions,
    secondaryType: answer.secondaryType,
    secondaryAnswer: answer.secondaryAnswer,
    otherDetails: answer.otherDetails,
    setAnswer: setAnswer,
    error: error,
    setError: setError,
    isOpen: answer.isOpen
  }), (answer.mainAnswer !== "" || answer.isOpen) && /*#__PURE__*/React.createElement(Navigation, {
    isLastQuestion: isLastQuestion,
    handleSubmit: handleSubmit,
    error: error,
    answer: answer,
    activeQuestionsIndex: activeQuestionsIndex
  })));
};
export default Questions;